export const DASHBOARD_PREFERENCES_VERSION = 1;

export const DASHBOARD_CARD_KEYS = {
  financialStats: 'financial_stats',
  financialRevenue: 'financial_revenue',
  financialExpenses: 'financial_expenses',
  financialNetProfit: 'financial_net_profit',
  financialOutstanding: 'financial_outstanding',
  financialGreenBean: 'financial_green_bean',
  financialRoasted: 'financial_roasted',
  financialFinished: 'financial_finished',
  greenBeanProfileInfographics: 'green_bean_profile_infographics',
  greenBeanSpecies: 'green_bean_species',
  greenBeanVarietals: 'green_bean_varietals',
  activityFeed: 'activity_feed',
  inventoryAlerts: 'inventory_alerts',
  inventoryExpiringSoon: 'inventory_expiring_soon',
  inventoryLowStock: 'inventory_low_stock',
  averageShrinkage: 'average_shrinkage',
  quickActions: 'quick_actions',
  aiAssistant: 'ai_assistant',
} as const;

export type DashboardCardKey = (typeof DASHBOARD_CARD_KEYS)[keyof typeof DASHBOARD_CARD_KEYS];
